import IconsSVG from './iconsSVG'
import HeadacheIcon from './headache'
import BlurryVisionIcon from './blurryVisionIcon'
import ChestPainIcon from './chestPainIcon'
import DonTBreatheIcon from './dontBreatheIcon'
import ThirstIcon from './thirstIcon'
import LostWeightIcon from './lostWeightIcon'
import DrowsinessIcon from './drowsinessIcon'
import ColdSweatIcon from './coldSweatIcon'
import WeaknessIcon from './weaknessIcon'
import FeetIcon from './feetIcon'
import NasalBleedingIcon from './nasalBleedingIcon'

const SymptomsIcon = {
	'Dolor de cabeza': (
		<span className='t-icon-status '>
			<HeadacheIcon />
		</span>
	),
	'Visión borrosa': (
		<span className='t-icon-status'>
			<BlurryVisionIcon />
		</span>
	),
	'Dolor en el pecho': (
		<span className='t-icon-status'>
			<ChestPainIcon />
		</span>
	),
	'Dificultad para respirar': (
		<span className='t-icon-status '>
			<DonTBreatheIcon />
		</span>
	),
	'Sangrado nasal': (
		<span className='t-icon-status'>
			<NasalBleedingIcon />
		</span>
	),
	Mareos: (
		<span>
			<IconsSVG icon='mareosIcon' />
		</span>
	),
	Sed: (
		<span className='t-icon-status'>
			<ThirstIcon />
		</span>
	),
	Orinadera: (
		<span>
			<IconsSVG icon='orinaderaIcon' />
		</span>
	),
	'Pérdida de peso': (
		<span className='t-icon-status'>
			<LostWeightIcon />
		</span>
	),
	Somnolencia: (
		<span className='t-icon-status '>
			<DrowsinessIcon />
		</span>
	),
	Temblor: (
		<span>
			<IconsSVG icon='temblorIcon' />
		</span>
	),
	'Sudoración fría': (
		<span className='t-icon-status'>
			<ColdSweatIcon />
		</span>
	),
	Debilidad: (
		<span className='t-icon-status'>
			<WeaknessIcon />
		</span>
	),
	'Alteración de la conciencia': (
		<span>
			<IconsSVG icon='alteracionDeLaConcienciaIcon' />
		</span>
	),
	'Infección en los pies o piel': (
		<span className='t-icon-status'>
			<FeetIcon />
		</span>
	),
	Triste: <span className='t-icon-status icon-triste' />,
	Alegre: <span className='t-icon-status icon-alegre' />,
	'Me siento bien': (
		<span>
			<IconsSVG icon='felizIcon' />
		</span>
	)
}

export default SymptomsIcon
